var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 24.9904C14.4548 24.9904 15.634 23.8113 15.634 22.3566C15.634 20.9019 14.4548 19.7227 13.0001 19.7227C11.5454 19.7227 10.3662 20.9019 10.3662 22.3566C10.3662 23.8113 11.5454 24.9904 13.0001 24.9904Z",
    fill: "white",
    stroke: "#0F20E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 1C11.5456 1 10.3662 2.17941 10.3662 3.63395C10.3662 5.0885 11.5456 6.26791 13.0001 6.26791C14.4546 6.26791 15.634 5.0885 15.634 3.63395C15.634 2.17941 14.4546 1 13.0001 1Z",
    fill: "white",
    stroke: "#0F20E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 15.6233C14.4548 15.6233 15.634 14.4441 15.634 12.9894C15.634 11.5348 14.4548 10.3555 13.0001 10.3555C11.5454 10.3555 10.3662 11.5348 10.3662 12.9894C10.3662 14.4441 11.5454 15.6233 13.0001 15.6233Z",
    fill: "white",
    stroke: "#0F20E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 15.6252C14.4548 15.6252 15.634 14.446 15.634 12.9914C15.634 11.5367 14.4548 10.3574 13.0001 10.3574C11.5454 10.3574 10.3662 11.5367 10.3662 12.9914C10.3662 14.446 11.5454 15.6252 13.0001 15.6252Z",
    fill: "white",
    stroke: "#0F20E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3663 15.6252C23.821 15.6252 25.0003 14.446 25.0003 12.9914C25.0003 11.5367 23.821 10.3574 22.3663 10.3574C20.9117 10.3574 19.7324 11.5367 19.7324 12.9914C19.7324 14.446 20.9117 15.6252 22.3663 15.6252Z",
    fill: "white",
    stroke: "#0F20E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63389 15.6252C5.08856 15.6252 6.26785 14.446 6.26785 12.9914C6.26785 11.5367 5.08856 10.3574 3.63389 10.3574C2.17923 10.3574 1 11.5367 1 12.9914C1 14.446 2.17923 15.6252 3.63389 15.6252Z",
    fill: "white",
    stroke: "#0F20E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 15.6252C14.4548 15.6252 15.634 14.446 15.634 12.9914C15.634 11.5367 14.4548 10.3574 13.0001 10.3574C11.5454 10.3574 10.3662 11.5367 10.3662 12.9914C10.3662 14.446 11.5454 15.6252 13.0001 15.6252Z",
    fill: "white",
    stroke: "#0F20E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0008 16.6559C15.0254 16.6559 16.6666 15.0146 16.6666 12.99C16.6666 10.9655 15.0254 9.32422 13.0008 9.32422C10.9762 9.32422 9.33496 10.9655 9.33496 12.99C9.33496 15.0146 10.9762 16.6559 13.0008 16.6559Z",
    fill: "white",
    stroke: "#0F20E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28569 12.9922H6.26855",
    stroke: "#0F20E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7428 12.9922H16.7256",
    stroke: "#0F20E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.001 16.7148V19.732",
    stroke: "#0F20E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.001 6.25781V9.27495",
    stroke: "#0F20E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.e4538fc4ee86e6e7d3c1df8b207cf38f.svg";
export { ForwardRef as ReactComponent };